import { createElement } from 'react';
import { useRouter } from 'next/router';
import { KlarnaPdpWidgetContainer } from './KlarnaPdpWidget.styles';

type KlarnaPdpWidgetProps = {
  dataPurchaseAmount?: number;
};

export function KlarnaPdpWidget({ dataPurchaseAmount }: KlarnaPdpWidgetProps) {
  const { locale } = useRouter();
  return (
    <KlarnaPdpWidgetContainer>
      {createElement('klarna-placement', {
        id: 'klarna-pdp-widget',
        'data-testid': 'klarnapaymentmessage',
        'data-key': 'credit-promotion-badge',
        'data-locale': locale,
        'data-purchase-amount': dataPurchaseAmount,
        'data-message-preference': 'klarna',
      })}
    </KlarnaPdpWidgetContainer>
  );
}
